window.oxgSidebarOpen = null;
window.oxgSidebarVisible = null;

export function oxgSidebarToggle() {
    const collapseBtn = document.getElementById('oxg-sidebar-collapse-btn')
    const expandBtn = document.getElementById('oxg-sidebar-expand-btn')
    const pageContainer = document.getElementById('oxg-page')
    const sidebar = document.getElementById('oxg-sidebar')
    const header = document.getElementById('oxg-header')
    if (!header || !collapseBtn || !pageContainer || (!pageContainer.classList.contains('layout-split-sidebar-right') && !pageContainer.classList.contains('layout-split-sidebar-left'))) return
    const aboveSidebar = document.getElementById('oxg-above-sidebar')
    const aboveSidebarCollapsed = document.getElementById('oxg-above-sidebar-collapsed')
    if (!aboveSidebarCollapsed || !aboveSidebar) return
    window.oxgSidebarVisible = window.oxg.win.w >= window.oxg.bp.m ? true : false
    window.oxgSidebarVisible = true
    !window.oxgSidebarOpen ? window.oxgSidebarOpen = true : false
    collapseBtn.addEventListener('click', (e)=> {
        e.preventDefault();
        if (window.oxgSidebarOpen && window.oxgSidebarVisible) {
            pageContainer.classList.add('sidebar-hidden')
            header.classList.add('sidebar-hidden')
            sidebar.classList.add('is-hidden')
            window.oxgSidebarOpen = false
            expandBtn.focus()
        }
    })
    expandBtn.addEventListener('click', (e)=> {
        e.preventDefault();
        if (!window.oxgSidebarOpen && window.oxgSidebarVisible) {
            pageContainer.classList.remove('sidebar-hidden')
            header.classList.remove('sidebar-hidden')
            sidebar.classList.remove('is-hidden')
            window.oxgSidebarOpen = true
            collapseBtn.focus()
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    oxgSidebarToggle();
    window.addEventListener('resize', ()=> {
        window.oxgSidebarVisible = window.oxg.win.w >= window.oxg.bp.m ? true : false
    })
})